var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM7.6129 6.2097C7.22061 5.90468 6.65338 5.93241 6.29289 6.29289C5.93241 6.65338 5.90468 7.22061 6.2097 7.6129L6.29289 7.70711L8.585 10L6.29289 12.2929L6.2097 12.3871C5.90468 12.7794 5.93241 13.3466 6.29289 13.7071C6.62334 14.0375 7.12751 14.0884 7.5114 13.8596L7.6129 13.7903L7.70711 13.7071L10 11.415L12.2929 13.7071L12.3871 13.7903C12.7794 14.0953 13.3466 14.0676 13.7071 13.7071C14.0676 13.3466 14.0953 12.7794 13.7903 12.3871L13.7071 12.2929L11.415 10L13.7071 7.70711L13.7903 7.6129C14.0953 7.22061 14.0676 6.65338 13.7071 6.29289C13.3767 5.96245 12.8725 5.91161 12.4886 6.14038L12.3871 6.2097L12.2929 6.29289L10 8.585L7.70711 6.29289L7.6129 6.2097Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilled);
export default __webpack_public_path__ + "static/media/close-filled.cdcaff5d.svg";
export { ForwardRef as ReactComponent };